import { IcInfoWarning } from '@assets/icons/24x24';
import { For, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import ActivationButtons from '@components/cockpit/panels/flightPlan/ActivationButtons';
import FlightPlanStatusIcon from '@components/cockpit/panels/flightPlan/FlightPlanStatusIcon';
import { NotificationDatesRange } from '@components/cockpit/panels/notification/card/NotificationDatesRange';
import FlightPlanDetails, { FlightPlanDetailsProps } from '@components/map/popup/infos/flightplans/FlightPlanDetails';
import { useIntl } from 'react-intl';

import { ActivationAndFlightPlan } from '@/types/utm/flightPlan.types';

interface FlightPlanDetailsWithValidationProps extends FlightPlanDetailsProps {
  activationAndFlightPlan: ActivationAndFlightPlan;
}

export default function FlightPlanDetailsWithValidation(props: Readonly<FlightPlanDetailsWithValidationProps>) {
  const { formatMessage } = useIntl();
  const { activationAndFlightPlan } = props;

  return (
    <FlightPlanDetails {...props}>
      <VStack width="100%" padding="standardM" backgroundColor="neutral.700" flex={1} align="start" gap={2}>
        {!(
          (activationAndFlightPlan.activation.status === 'ACCEPTED' ||
            activationAndFlightPlan.activation.status === 'REJECTED') &&
          !activationAndFlightPlan.activation.validatedOrRejectedBy
        ) && (
          <FlightPlanStatusIcon
            status={activationAndFlightPlan.activation.status}
            validatedOrRejectedBy={activationAndFlightPlan.activation.validatedOrRejectedBy}
            validationOrRejectionTime={activationAndFlightPlan.activation.validationOrRejectionTime}
            showDescription
          />
        )}
        <For each={activationAndFlightPlan.activation.conflicts}>
          {(conflict) => (
            <HStack gap={1} width="100%" alignItems="start">
              <Icon as={IcInfoWarning} color="red.500" boxSize="24px" />
              <VStack width="100%" flex={1} align="start">
                <Text fontSize="sm">
                  {formatMessage(
                    { id: 'components.flightPlans.conflictingFlightPlanCode' },
                    { conflictingFlightPlanCode: conflict.conflictingFlightPlanCode },
                  )}
                </Text>
                <NotificationDatesRange startTime={conflict.interval.from} endTime={conflict.interval.to} />
              </VStack>
            </HStack>
          )}
        </For>
        <ActivationButtons activationAndFlightPlan={activationAndFlightPlan} showEditAndDeleteButtons={false} />
      </VStack>
    </FlightPlanDetails>
  );
}
